import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import axios from 'axios';
import jsPDF from 'jspdf';
import './worker_registrations.css';
import '../assets/animate/animate.css';
import '../assets/animate/animate.min.css';
import '../assets/css/style.css';
import BASE_URL from '../context/AppConfig';


function WorkerRegistration() {
    const [worker, setWorker] = useState({
        worker_id: '',
        name: '',
        job_role: '',
        hourly_rate: '40',
        wage_type: 'daily',
        worksite: ''
    });

    const [qrData, setQrData] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState(null);

    const handleChange = (e) => {
        setWorker({ ...worker, [e.target.name]: e.target.value });
    };

    const generateQRCode = () => {
        const qrString = `ID: ${worker.worker_id}\nName: ${worker.name}\nJob Role: ${worker.job_role}\nHourly Rate: ${worker.hourly_rate}\nWage Type: ${worker.wage_type}\nWorksite: ${worker.worksite}`;
        setQrData(qrString);
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     generateQRCode();  // Generate QR code before submitting
    //     // Ensure QR code is generated  
        

    //     // Convert QR Code to image blob
    //     const canvas = document.getElementById('qrCodeCanvas');
    //     const imageUrl = canvas.toDataURL('image/png');

    //     // Convert Data URL to File
    //     const blob = await fetch(imageUrl).then(res => res.blob());
    //     const file = new File([blob], `qr_${worker.worker_id}.png`, { type: 'image/png' });

    //     const formData = new FormData();
    //     formData.append('worker_id', worker.worker_id);
    //     formData.append('name', worker.name);
    //     formData.append('job_role', worker.job_role);
    //     formData.append('wage_type', worker.wage_type);
    //     formData.append('worksite', worker.worksite);
    //     formData.append('qr_code', file);

    //     const token = localStorage.getItem('token');  // Retrieve the token

    //     try {
    //         const response = await axios.post('http://localhost:8000/api/register-worker/', formData,{
    //             headers: {
    //               Authorization: `Bearer ${token}`,
    //             },});

    //         setQrCodeUrl(response.data.qr_code);
    //         downloadQRCode();  // Download the QR code after successful registration
    //         setWorker({
    //             worker_id: '',
    //             name: '',
    //             job_role: '',
    //             wage_type: 'daily',
    //             worksite: ''
    //         });
    //         alert('Worker Registered Successfully!');
    //     } catch (error) {
    //         console.error('Error saving worker:', error);
    //     }
    // };
    

const handleSubmit = async (e) => {
    e.preventDefault();
    generateQRCode();

    await new Promise(resolve => setTimeout(resolve, 0)); // Wait for QR code to render

    const canvas = document.getElementById('qrCodeCanvas');
    if (!canvas) {
        alert("QR Code not generated yet. Please try again.");
        return;
    }

    const imageUrl = canvas.toDataURL('image/png');
    const blob = await fetch(imageUrl).then(res => res.blob());
    const file = new File([blob], `qr_${worker.worker_id}.png`, { type: 'image/png' });

    const formData = new FormData();
    formData.append('worker_id', worker.worker_id);
    formData.append('name', worker.name);
    formData.append('job_role', worker.job_role);
    formData.append('wage_type', worker.wage_type);
    formData.append('worksite', worker.worksite);
    formData.append('qr_code', file);

    const token = localStorage.getItem('token');

    try {
        const response = await axios.post(`${BASE_URL}/register-worker/`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // 🧾 Create PDF
        const pdf = new jsPDF();
        pdf.setFontSize(16);
        pdf.text('Worker Registration Details', 20, 20);

        pdf.setFontSize(12);
        pdf.text(`Worker ID: ${worker.worker_id}`, 20, 40);
        pdf.text(`Name: ${worker.name}`, 20, 50);
        pdf.text(`Job Role: ${worker.job_role}`, 20, 60);
        pdf.text(`Hourly Rate: ${worker.hourly_rate}`, 20, 70);
        pdf.text(`Wage Type: ${worker.wage_type}`, 20, 80);
        pdf.text(`Worksite: ${worker.worksite}`, 20, 90);

        pdf.addImage(imageUrl, 'PNG', 140, 40, 60, 60); // Add QR code to the right side

        pdf.save(`worker_${worker.worker_id}.pdf`);

        setWorker({
            worker_id: '',
            name: '',
            job_role: '',
            hourly_rate: '40',
            wage_type: 'daily',
            worksite: ''
        });

        alert('Worker Registered Successfully and PDF downloaded!');
    } catch (error) {
        console.error('Error saving worker:', error);
        alert('Worker registration failed.');
    }
};

    

    const downloadQRCode = () => {
        const canvas = document.getElementById('qrCodeCanvas');
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = image;
        link.download = `worker_${worker.worker_id}.png`;
        link.click();
    };

    return (
        <div className="container mt-5  border-0  shadow p-0 " style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
            
            
            <div className='reg-container'>
                <div className='leftside'></div>
                <div className='form-container'>
            <h1 className="text-center mb-4 fadeInRight">Worker Registration</h1>
            <form className='fadeInLeft'  onSubmit={handleSubmit}>
                <div className="mb-3">

                    <label>Worker ID:</label>

                    <input type="text" name="worker_id" value={worker.worker_id} onChange={handleChange} required className="form-control" />
                </div>

                <div className="mb-3">
                    <label>Name:</label>
                    <input type="text" name="name" value={worker.name} onChange={handleChange} required className="form-control" />
                </div>

                <div className="mb-3">
                    <label>Job Role:</label>
                    <input type="text" name="job_role" value={worker.job_role} onChange={handleChange} required className="form-control" />
                </div>

                <div className="mb-3">
                    <label>Wage Type:</label>
                    <select name="wage_type" value={worker.wage_type} onChange={handleChange} className="form-control">
                        <option value="daily">Daily Wage</option>
                        <option value="tender">Tender-Based</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label>Hourly Rate:</label>
                    <input type="text" name="hourly_rate" value={worker.hourly_rate} onChange={handleChange} required className="form-control" />
                </div>

                <div className="mb-3">
                    <label>Worksite:</label>
                    <input type="text" name="worksite" value={worker.worksite} onChange={handleChange} required className="form-control" />
                </div>

                {/* <button type="button" className="btn btn-primary" onClick={generateQRCode}>Generate QR Code</button> */}
                <button type="submit" className="btn btn-success ms-2 text-center">Register Worker</button>
            </form>
            </div>
            </div>

            

            {qrData && (
                <div className="mt-3">
                    <h3>QR Code:</h3>
                    <QRCodeCanvas id="qrCodeCanvas" value={qrData} size={150} />
                    <br />
                    <button className="btn btn-info mt-2" onClick={downloadQRCode}>Download QR Code</button>
                </div>
            )}
        </div>
    );
}

export default WorkerRegistration;
